import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { IssueCustomerMessage } from '../../model/issue-customer-message.model';
import { IssueSelfHelpModel } from '../../model/issue-selfhelp.model';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueModel } from '../../model/issue.model';
import { IssueService } from '../../service/issue.service';
import { CustomerDialogComponent } from '../customer-dialog/customer-dialog.component';
import { IssuesEditModalComponent } from '../issues-edit-modal/issues-edit-modal.component';
import { KeywordDialogComponent } from '../keyword-dialog/keyword-dialog.component';
import { SiteMessagesDialogComponent } from '../site-messages-dialog/site-messages-dialog.component';

@Component({
  selector: 'issue-list-results',
  templateUrl:
    'console/app-js/modules/issue/components/issue-list-results/issue-list-results.component.html',
  encapsulation: ViewEncapsulation.None
})
export class IssueListResultComponent extends APIOperableComponent {
  protected issueModel: IssueModel = new IssueModel();
  protected issueSelfHelpModel: IssueSelfHelpModel = new IssueSelfHelpModel();
  protected issueCustomerMessage: IssueCustomerMessage = new IssueCustomerMessage();
  protected loading: Boolean = false;
  protected issueData = [];
  protected openCustomerMessage = false;
  protected hasCustomerMessages = false;
  protected openSelfhelp = false;
  protected openSiteSpecificMessage = false;
  protected hasSiteSpecificMessages = false;
  protected customerMessageDetails: IssueCustomerMessage;
  private selectedCustomer: string;
  @Input('noRecordsSettings') noRecordsSettings;
  @Input('data') data: any[];
  @Input('columns') issueColumns: any;
  @Input('loading') gridLoading: Boolean;
  @Output('reload') reload = new EventEmitter();
  constructor(
    protected progressService: NgProgress,
    protected toastr: ToastrService,
    protected authService: AuthService,
    private issueService: IssueService,
    protected dialogService: UIDialogService,
    private router: Router
  ) {
    super(progressService, toastr, authService);
  }

  ngOnChanges() {
    this.loading = this.gridLoading;
    this.loadItems();
  }

  /**
   * Load grid Items
   */
  private loadItems(): void {
    this.selectedCustomer = localStorage.getItem('cNum');
    if (this.data !== undefined && this.data.length !== 0) {
      this.issueData = JSON.parse(JSON.stringify(this.data));
      this.issueData.forEach(obj => {
        obj['keywords'] = this.convertToHtmlContent(
          obj.keywords,
          'keyword-edit'
        );
        obj['customerNumbers'] = this.convertToHtmlContent(
          obj.customerNumbers,
          'customer-edit'
        );
        obj['name'] = this.convertToHtmlContent(obj.name, 'issue-edit');
        obj['hasQuestions'] = this.convertToHtmlContent(
          obj.hasQuestions,
          'question-edit'
        );
        obj['hasSelfHelp'] = this.convertToHtmlContent(
          obj.hasSelfHelp,
          'self-help'
        );
        obj['hasMessages'] = this.convertToHtmlContent(
          obj.hasMessages,
          'messages-edit'
        );
        obj['hasSiteMessages'] = this.convertToHtmlContent(
          obj.hasSiteMessages,
          'site-messages'
        );
        obj['hasSiteSpecificMessages'] = this.convertToHtmlContent(
          obj.hasSiteSpecificMessages,
          'siteSpecificMessages-edit'
        );
      });
    } else {
      this.issueData = [];
    }
  }
  /**
   * save edited issue.
   */
  onEditItem(issueModel: IssueModel): void {
    this.startProgress();
    this.issueService.updateIssue(issueModel).subscribe(
      result => {
        if (result.responseCode === 200) {
          this.finishProgress();
          this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
          this.reload.emit(true);
        } else {
          this.onAPIError(result.errorMessage);
        }
      },
      err => {
        this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
        this.finishProgress();
      }
    );
  }

  /**
   * handler for click cell
   */
  public cellClickHandler($event) {
    const originalEvent = $event.originalEvent;
    if (originalEvent.target.classList.contains('keyword-edit')) {
      this.onEdit($event.dataItem, 'keyword');
    } else if (originalEvent.target.classList.contains('customer-edit')) {
      this.onEditCustomer($event.dataItem);
    } else if (originalEvent.target.classList.contains('issue-edit')) {
      this.onEdit($event.dataItem, 'issues');
    } else if (originalEvent.target.classList.contains('question-edit')) {
      const issueId = $event.dataItem.id;
      this.router.navigate([`/console/issue/${issueId}/question`]);
    } else if (originalEvent.target.classList.contains('self-help')) {
      this.onEdit($event.dataItem, 'self-help');
    } else if (originalEvent.target.classList.contains('messages-edit')) {
      this.onEdit($event.dataItem, 'custMessages');
    } else if (originalEvent.target.classList.contains('site-messages')) {
      this.onEdit($event.dataItem, 'site-messages');
    } else if (
      originalEvent.target.classList.contains('siteSpecificMessages-edit')
    ) {
      this.onEdit($event.dataItem, 'siteSpecificMessages');
    }
  }
  /***
   * keyword & Issue & Self Help popup
   */
  onEdit(dataItem, value): void {
    if (value === 'issues') {
      this.dialogService
        .open(IssuesEditModalComponent, [
          {
            provide: 'issueModel',
            useValue: this.data.filter(item => item.id === dataItem.id)
          }
        ])
        .then(result => {
          if (result) {
            this.onEditItem(result);
          }
        });
    } else if (value === 'keyword') {
      this.dialogService
        .open(KeywordDialogComponent, [
          {
            provide: 'currentIssueModel',
            useValue: this.data.filter(item => item.id === dataItem.id)
          }
        ])
        .then(result => {
          if (result) {
            this.reload.emit(true);
          }
        });
    } else if (value === 'self-help') {
      this.loadSelfHelpDetails(
        this.data.filter(item => item.id === dataItem.id)
      );
    } else if (value === 'custMessages') {
      this.loadCustomerMessageDetails(
        this.data.filter(item => item.id === dataItem.id)
      );
    } else if (value === 'site-messages') {
      this.dialogService.open(SiteMessagesDialogComponent, [
        {
          provide: 'currentIssueModel',
          useValue: this.data.filter(item => item.id === dataItem.id)
        }
      ]);
    } else if (value === 'siteSpecificMessages') {
      this.loadSiteSpecificMessageDetails(
        this.data.filter(item => item.id === dataItem.id)
      );
    }
  }
  /***
   * Customer popup
   */
  onEditCustomer(dataItem): void {
    this.dialogService
      .open(CustomerDialogComponent, [
        {
          provide: 'user',
          useValue: this.data.filter(item => item.id === dataItem.id)
        }
      ])
      .then(result => {
        if (result) {
          this.reload.emit(true);
        }
      });
  }

  /**
   * Customer Message Details
   */
  loadCustomerMessageDetails(dataItem): void {
    this.startProgress();
    this.issueCustomerMessage = new IssueCustomerMessage();
    this.issueCustomerMessage.issueId = dataItem[0].id;
    this.issueCustomerMessage.customerNumber = dataItem[0].customerNumbers[0];
    if (dataItem[0].id !== undefined) {
      this.issueService
        .getCustomerMessageDetail(
          dataItem[0].id,
          dataItem[0].customerNumbers[0]
        )
        .subscribe(
          result => {
            let testCustomerMessage = new IssueCustomerMessage();
            if (result.status !== 504) {
              if (result.results.length > 0) {
                testCustomerMessage = result.results.find(function(element) {
                  return (
                    element.endDate === undefined ||
                    moment(new Date(element.endDate)).format('YYYY/MM/DD') >
                      moment(new Date()).format('YYYY/MM/DD')
                  );
                });
              }
              if (
                testCustomerMessage !== undefined &&
                Object.keys(testCustomerMessage).length > 0
              ) {
                this.issueCustomerMessage = testCustomerMessage;
              }
              this.finishProgress();
              this.onCustomerMessageDetailEdit(this.issueCustomerMessage);
            }
          },
          err => {
            this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
            this.finishProgress();
          }
        );
    }
  }

  loadSiteSpecificMessageDetails(dataItem): void {
    this.startProgress();
    this.issueCustomerMessage = new IssueCustomerMessage();
    this.issueCustomerMessage.issueId = dataItem[0].id;
    this.issueCustomerMessage.customerNumber = dataItem[0].customerNumbers[0];
    this.issueCustomerMessage.siteId = dataItem[0].siteId;
    this.issueCustomerMessage.siteNumber = dataItem[0].siteNumber;
    if (dataItem[0].id !== undefined) {
      this.issueService
        .getsiteSpecificMessageDetail(
          dataItem[0].id,
          dataItem[0].customerNumbers[0],
          dataItem[0].siteId
        )
        .subscribe(
          result => {
            let testCustomerMessage = new IssueCustomerMessage();
            if (result.status !== 504) {
              if (result.results.length > 0) {
                testCustomerMessage = result.results.find(function(element) {
                  return (
                    element.endDate === undefined ||
                    moment(new Date(element.endDate)).format('YYYY/MM/DD') >
                      moment(new Date()).format('YYYY/MM/DD')
                  );
                });
              }
              if (
                testCustomerMessage !== undefined &&
                Object.keys(testCustomerMessage).length > 0
              ) {
                let siteNumber = this.issueCustomerMessage.siteNumber;
                this.issueCustomerMessage = testCustomerMessage;
                this.issueCustomerMessage.siteNumber = siteNumber;
              }
              this.finishProgress();
              this.onSiteSpecificMessageDetailEdit(this.issueCustomerMessage);
            }
          },
          err => {
            this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
            this.finishProgress();
          }
        );
    }
  }

  /**
   * Self Help API call.
   */
  loadSelfHelpDetails(dataItem): void {
    this.startProgress();
    if (dataItem[0].id !== undefined) {
      this.issueService.getSelfHelpDetail(dataItem[0].id).subscribe(
        result => {
          this.issueSelfHelpModel = result;
          this.issueSelfHelpModel.issueName = dataItem[0].name;
          this.finishProgress();
          this.onSelfHelpEdit(this.issueSelfHelpModel);
        },
        err => {
          this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
          this.finishProgress();
        }
      );
    }
  }

  closed(event) {
    this.openCustomerMessage = false;
    this.reload.emit(event);
  }

  closedSiteSpecificMessages(event) {
    this.openSiteSpecificMessage = false;
    this.reload.emit(event);
  }
  closedSelfhelp(event) {
    this.openSelfhelp = false;
    this.reload.emit(event);
  }
  onCustomerMessageDetailEdit(
    customerMessageDetails: IssueCustomerMessage
  ): void {
    this.customerMessageDetails = customerMessageDetails;
    this.hasCustomerMessages =
      this.customerMessageDetails.messageText !== undefined;
    this.openCustomerMessage = true;
  }

  onSiteSpecificMessageDetailEdit(
    customerMessageDetails: IssueCustomerMessage
  ): void {
    this.customerMessageDetails = customerMessageDetails;
    this.hasSiteSpecificMessages =
      this.customerMessageDetails.messageText !== undefined;
    this.openSiteSpecificMessage = true;
  }
  onSelfHelpEdit(issueSelfHelpModel: IssueSelfHelpModel): void {
    this.issueSelfHelpModel = issueSelfHelpModel;
    this.openSelfhelp = true;
  }

  /**
   * Converts the User Groups to HTML content for the Vixxo UI Grid.
   * A
   * @param values: string result.
   */
  private convertToHtmlContent(values, className): string {
    let newValues = values;
    if (Array.isArray(values)) {
      newValues = values.join().replace(/,/g, ', ');
    }
    let AsHtml;
    AsHtml = '<div class="pull-left">';
    AsHtml = AsHtml.concat(`<div>${newValues} </div>`);
    AsHtml = AsHtml.concat('</div>');
    if (className === 'site-messages') {
      if (values === 'Yes') {
        AsHtml = AsHtml.concat(`<div class="pull-right ${className}-p"><a class="group-edit-c">
      <img src="../console/image/svgs/site-message-new-window.svg" class="${className}" />
      </a></div>`);
      } else {
        AsHtml = AsHtml.concat(`<div class="pull-right ${className}-p"><a class="group-edit-c no-display">
        <img src="../console/image/svgs/site-message-new-window.svg" class="${className}" />
        </a></div>`);
      }
    } else if (this.checkCustomerQuestions(className)) {
      if (values === 'Yes') {
        AsHtml = AsHtml.concat(`<div class="pull-right ${className}-p"><a class="group-edit-c">
      <span class="${className} glyphicon glyphicon-pencil"></span></a></div>`);
      } else {
        AsHtml = AsHtml.concat(`<div class="pull-right ${className}-p"><a class="group-edit-c no-display">
      <span class="${className} glyphicon glyphicon-pencil"></span></a></div>`);
      }
    } else {
      AsHtml = AsHtml.concat(`<div class="pull-right ${className}-p"><a class="group-edit-c">
      <span class="${className} glyphicon glyphicon-pencil"></span></a></div>`);
    }
    return AsHtml;
  }

  private checkCustomerQuestions(className): boolean {
    return className === 'question-edit' && this.selectedCustomer !== null;
  }
}
